export default "__VITE_ASSET__goRI332M__"